module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-1000.8ae7ea51.svg";